import type { OrderItemDraft } from '@/components/forms/order-item-row'
import { newMaterialRowId } from '@/lib/material-row-id'

/** Dựng một dòng sản phẩm trống cho màn sửa đơn.
 *
 *  `id` được gán NGAY thay vì để rỗng: id đóng vai trò line_key nối vật tư với
 *  dòng sản phẩm. Nếu để rỗng, hook đồng bộ gửi line_key rỗng, backend fallback
 *  sang product_id, và dòng vật tư trả về sẽ không khớp bộ lọc nào — không hiện
 *  dưới sản phẩm (lọc theo item.id), cũng không phải dòng thêm tay (lọc
 *  !line_key) — nhưng vẫn cộng vào tổng tiền và vẫn đi vào payload.
 *
 *  Id chỉ sống ở client: payload items không gửi trường id, backend tự tạo lại
 *  order_item và map qua order_item_index.
 */
export function newOrderItemDraft(discountPercent = 0): OrderItemDraft {
    return {
        id: newMaterialRowId(),
        product_id: '',
        product_name: '',
        quantity: 1,
        unit_price: 0,
        discount_percent: discountPercent,
    }
}
